module.exports = __webpack_public_path__ + "static/favicon-16x16-714ae462fbf6c7aa255b18d2d79572bb.png";